import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FieldTypes } from 'app/shared/model/enums';

@Component({
  selector: 'app-payment-card-mobile',
  templateUrl: './payment-card-mobile.component.html',
  styleUrls: ['./payment-card-mobile.component.scss']
})


export class PaymentCardMobileComponent implements OnInit {
  @Input()
  currentPayment
  @Input()
  columns
  fieldTypes=FieldTypes 

  constructor() { }

  ngOnInit(): void {
    console.log(this.currentPayment)
  }
}
